import { DebugLog } from './debug-log';

export function capitalize(str: string) {
  return str.replace(/\b\w/g, l => {
    return l.toUpperCase();
  });
}

export function extractCSS(element: HTMLElement, style: string) {
  return window.getComputedStyle(element, null).getPropertyValue(style);
}

export function once(fn: any, context?: any) {
  let result: any;
  return function(this: any) {
    if (fn) {
      result = fn.apply(context || this, arguments);
      fn = null;
    }
    return result;
  };
}

// tslint:disable:no-console
// All functions embed in this function will share the same timer
let lastSharedFunctionExecutionMS: number = 0;
const singleCallTimerShared: number = 2000;
export function preventSpamCallsShared(fn: any) {
  return (...args: any) => {
    if (Date.now() - lastSharedFunctionExecutionMS > singleCallTimerShared) {
      lastSharedFunctionExecutionMS = Date.now();
      return fn(...args);
    } else {
      // debug
      DebugLog.log(
        `call to fast to the function, wait ${singleCallTimerShared -
          (Date.now() - lastSharedFunctionExecutionMS)} ms`
      );
    }
  };
}

// All functions embed in this function will NOT share the same timer
export function preventSpamCalls(fn: any) {
  let lastFunctionExecutionMS: number = 0;
  const singleCallTimer: number = 2000;
  return () => {
    if (Date.now() - lastFunctionExecutionMS > singleCallTimer) {
      lastFunctionExecutionMS = Date.now();
      return fn();
    } else {
      // debug
      DebugLog.log(
        `call to fast to the function, wait ${singleCallTimer -
          (Date.now() - lastFunctionExecutionMS)} ms`
      );
    }
  };
}
// tslint:enable:no-console

/* tslint:disable:no-bitwise */
export function convertStrToBase64(str: string) {
  const CHARS =
    'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
  let out = '';
  let i = 0;
  const len = str.length;
  let c1;
  let c2;
  let c3;
  while (i < len) {
    c1 = str.charCodeAt(i++) & 0xff;
    if (i === len) {
      out += CHARS.charAt(c1 >> 2);
      out += CHARS.charAt((c1 & 0x3) << 4);
      out += '==';
      break;
    }
    c2 = str.charCodeAt(i++);
    if (i === len) {
      out += CHARS.charAt(c1 >> 2);
      out += CHARS.charAt(((c1 & 0x3) << 4) | ((c2 & 0xf0) >> 4));
      out += CHARS.charAt((c2 & 0xf) << 2);
      out += '=';
      break;
    }
    c3 = str.charCodeAt(i++);
    out += CHARS.charAt(c1 >> 2);
    out += CHARS.charAt(((c1 & 0x3) << 4) | ((c2 & 0xf0) >> 4));
    out += CHARS.charAt(((c2 & 0xf) << 2) | ((c3 & 0xc0) >> 6));
    out += CHARS.charAt(c3 & 0x3f);
  }
  return out;
}

export function hashString(strToHash: string) {
  return strToHash.split('').reduce((acc, currentChar) => {
    acc = (acc << 5) - acc + currentChar.charCodeAt(0);
    return acc & acc;
  }, 0);
}

export function generateLink(url: string): HTMLElement {
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('target', '_blank');
  return link;
}

/**
 * String replace using a function to avoid special replacement patterns
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/replace#specifying_a_function_as_the_replacement
 */
export function replacerWithoutPattern(
  inputValue: string,
  searchValue: string | RegExp,
  replaceValue: string
): string {
  return inputValue?.replace(searchValue, () => replaceValue);
}
